module.exports = __webpack_public_path__ + "static/media/nav-bg-liikenne.4a4cbef9.svg";